export default __webpack_public_path__ + "static/media/CPASAGE_Client home page icons-13.5757182a.svg";